import { observable, computed, action, toJS } from 'mobx'
import qs from 'qs'
import _get from 'lodash/get'
import _mapValues from 'lodash/mapValues'
import _omitBy from 'lodash/omitBy'
import _isNil from 'lodash/isNil'
import _isEqual from 'lodash/isEqual'
import config from '~/config'
import userStore from '~/stores/user'
// import user from '~/user.json'
// const { param } = user.data.claims
// const {
//   catchment_id: defaultCatchmentId
// } = param
// const { params: { catchment_id: defaultCatchmentId } } = userStore.profile
const defaultCatchmentId = _get(userStore, 'profile.params.catchment_id', 1)
const defaultResponse = _get(config, 'app.defaults.responseDataTypes', {})
const defaultForcing = _get(config, 'app.defaults.forcingDataTypes', {})

class ViewStore {
  @observable mode = null
  @observable catchmentId = defaultCatchmentId || null
  @observable stationIds = []
  @observable poiId = null
  @observable poiIds = []
  @observable scenarioIds = []
  @observable flocIds = []
  @observable dataTypeIds = {
    response: observable.map(defaultResponse),
    forcing: observable.map(defaultForcing)
  }
  @observable daysOffset = null

  @computed get currentPath () {
    const queryProps = {
      catchmentId: this.catchmentId,
      stationIds: JSON.stringify(this.stationIds.toJS()),
      response: this.dataTypeIds.response && _mapValues(toJS(this.dataTypeIds.response), JSON.stringify),
      forcing: this.dataTypeIds.forcing && _mapValues(toJS(this.dataTypeIds.forcing), JSON.stringify),
      offset: this.daysOffset,
      poi: this.poiId,
      poiIds: JSON.stringify(this.poiIds.toJS()),
      scenarioIds: JSON.stringify(this.scenarioIds.toJS()),
      flocIds: JSON.stringify(this.flocIds.toJS())
    }
    // TODO: this logic is router dependent
    const query = qs.stringify(
      _omitBy(queryProps, val => _isNil(val)), {
        addQueryPrefix: true,
        encode: false
      }
    )
    let path = '/'
    if (this.mode) {
      path += this.mode
    }
    if (query) {
      path += query
    }
    return path
  }
  getDataTypeIds ({ kind, categoryId }) {
    const dataTypeIds = toJS(this.dataTypeIds[kind])
    return dataTypeIds[categoryId]
  }
  @action setPoiId (poiId) {
    this.poiId = parseInt(poiId, 10)
    // this.setStationIds([])
  }
  @action setCatchmentId () {

  }
  @action setStationIds (stationIds = []) {
    this.stationIds.replace(stationIds.map(sId => parseInt(sId, 10)))
    // this.poiId = null
  }
  @action setPoiIds (poiIds = []) {
    this.poiIds.replace(poiIds.map(pId => parseInt(pId, 10)))
    // this.poiId = null
  }
  @action setScenarioIds (scenarioIds = []) {
    this.scenarioIds.replace(scenarioIds.map(scId => parseInt(scId, 10)))
    // this.poiId = null
  }
  @action setFlocIds (flocIds = []) {
    // console.log({ flocIds })
    this.flocIds.replace(flocIds.map(flocId => parseInt(flocId, 10)))
    // this.poiId = null
  }
  @action addPoiId (poiId) {
    const poiIds = this.poiIds.concat(parseInt(poiId, 10))
    this.poiIds.replace(poiIds)
  }
  @action removePoiId (poiId) {
    const poiIds = this.poiIds.filter(pId => pId !== parseInt(poiId, 10))
    this.poiIds.replace(poiIds)
  }
  @action setDaysOffset (days) {
    const offset = parseInt(days, 10)
    if (!isNaN(offset)) {
      this.daysOffset = offset
    }
  }
  @action setDataTypeIds ({ kind, categoryId, dataTypeIds }) {
    this.dataTypeIds[kind].set(categoryId, dataTypeIds)
  }
  @action update ({ mode, catchmentId, stationIds = [], poiIds = [], scenarioIds = [], flocIds = [], dataTypeIds = {}, daysOffset, poiId }) {
    this.mode = mode || null
    this.catchmentId = parseInt(catchmentId, 10) || defaultCatchmentId || null
    // if (parseInt(stationIds, 10)) {
    this.setStationIds(stationIds)
    this.setPoiIds(poiIds)
    this.setScenarioIds(scenarioIds)
    this.setFlocIds(flocIds)
    // this.poiId = null
    // }
    // if (poiId) {
    this.poiId = parseInt(poiId, 10) || null
    // console.log(this.stationIds, this.poiId)
    // this.stationIds = null
    // }
    this.daysOffset = _isNil(daysOffset) ? null : parseInt(daysOffset, 0)
    const currentResponse = toJS(this.dataTypeIds.response)
    if (dataTypeIds.response) {
      if (!_isEqual(currentResponse, dataTypeIds.response)) {
        Object.entries(dataTypeIds.response).forEach(([categoryId, ids]) => {
          this.dataTypeIds.response.set(parseInt(categoryId, 10), ids)
        })
      }
    } else if (!_isEqual(currentResponse, defaultResponse)) {
      this.dataTypeIds.response = observable.map(defaultResponse)
    }
    const currentForcing = toJS(this.dataTypeIds.forcing)
    if (dataTypeIds.forcing) {
      if (!_isEqual(currentForcing, dataTypeIds.forcing)) {
        Object.entries(dataTypeIds.forcing).forEach(([categoryId, ids]) => {
          this.dataTypeIds.forcing.set(parseInt(categoryId, 10), ids)
        })
      }
    } else if (!_isEqual(currentForcing, defaultForcing)) {
      this.dataTypeIds.forcing = observable.map(defaultForcing)
    }
    // console.log({ poiId })
  }
}
const viewStore = new ViewStore()
export default viewStore



// WEBPACK FOOTER //
// ./src/stores/view.js